import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo_news_factory.svg';
import { useSelector } from 'react-redux';
import Logout from '../logout/Logout';
import { selectFormattedUserEmail, selectIsSsoUser } from '../selectors/userSelectors';

function Header() {
    const email = useSelector(selectFormattedUserEmail);
    const isSsoUser = useSelector(selectIsSsoUser);
    const [isDropdownOpen, setDropdownOpen] = useState(false);
    const toggleDropdown = () => setDropdownOpen(!isDropdownOpen);

    useEffect(() => {
        if (email === '') {
            setDropdownOpen(false);
        }
    }, [email]);

    return (
        <div className="inline-flex items-center justify-between w-full bg-white h-[7vh] px-6 py-3 relative">
            <a href={email !== '' ? '/dashboard' : '/login'}>
                <img src={logo} className="w-[200px] max-w-[250px] h-full" alt="newsfactory_logo" />
            </a>
            {email !== '' && !isSsoUser ? (
                <div className="relative">
                    <button
                        className="flex flex-row flex-nowrap items-baseline content-center rounded-[1.5rem] px-4 py-2 text-small leading-6 bg-light-gray "
                        onClick={toggleDropdown}
                    >
                        <span className="mr-1">{email}</span>
                        <span className="flex relative w-[6px] h-[6px] border-t-2 border-l-2 border-dark-gray rounded-[10%] transition-all duration-300 ease-in-out m-[5px] rotate-[225deg]" />
                    </button>
                    {isDropdownOpen && (
                        <div className="absolute right-0 w-full bg-primary shadow-lg z-[1] rounded-[12px] text-center mt-[5px] uppercase font-primary text-small font-medium py-[5px]">
                            <Logout />
                        </div>
                    )}
                </div>
            ) : !isSsoUser ? (
                <Link
                    className="flex flex-row items-baseline rounded-[1.5rem] px-4 py-2 text-[16px] leading-6"
                    to={'login'}
                >
                    {' '}
                    Login{' '}
                </Link>
            ) : (
                <></>
            )}
        </div>
    );
}

export default Header;
